import ValidService from "../../../service/ValidService";

let model = {};

// dữ liệu form
model.dataForm = {

};

model.dataModalDetail = {
  TenCoSo: null,
  ThoiGianDieuTri: null,
  TenBenh: null,
  KetQuaDieuTri: null,
  BacSyDieuTri: null,
  HinhThucRaVien: null,
  SidCode: null,
  hsId: null,
};

// validation form
model.validForm = {};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.dataFormDoctor = {
  cardCode: ""
};
model.dataFormCheckQuyen = {
  status: "chuaGui",
  mobile: "",
  otp: ""
};
model.validFormDoctor = {
  cardCode: []
};
model.validFormCheckQuyen = {
  status: [],
  mobile: [],
  otp: [],
};

model.resHL7Demo = {
  "HanhChinh": {
    "Identifier": [
      {
        "UseElement": null,
        "Type": null,
        "SystemElement": null,
        "ValueElement": {
          "Value": "'19065267'",
          "ElementId": null,
          "Extension": []
        },
        "Period": null,
        "Assigner": null,
        "ElementId": null,
        "Extension": []
      },
      {
        "UseElement": null,
        "Type": null,
        "SystemElement": null,
        "ValueElement": {
          "Value": "25095",
          "ElementId": null,
          "Extension": []
        },
        "Period": null,
        "Assigner": null,
        "ElementId": null,
        "Extension": []
      },
      {
        "UseElement": null,
        "Type": null,
        "SystemElement": null,
        "ValueElement": {
          "Value": "2520285527",
          "ElementId": null,
          "Extension": []
        },
        "Period": null,
        "Assigner": null,
        "ElementId": null,
        "Extension": []
      }
    ],
    "ActiveElement": null,
    "Name": [
      {
        "UseElement": null,
        "TextElement": null,
        "FamilyElement": {
          "Value": "Vũ",
          "ElementId": null,
          "Extension": []
        },
        "GivenElement": [
          {
            "Value": "Văn Đốc",
            "ElementId": null,
            "Extension": []
          }
        ],
        "PrefixElement": [],
        "SuffixElement": [],
        "Period": null,
        "ElementId": null,
        "Extension": []
      }
    ],
    "Telecom": [],
    "GenderElement": {
      "Value": 0,
      "ElementId": null,
      "Extension": []
    },
    "BirthDateElement": {
      "Value": "1953-10-6",
      "ElementId": null,
      "Extension": []
    },
    "Deceased": null,
    "Address": [],
    "MaritalStatus": null,
    "MultipleBirth": null,
    "Photo": [],
    "Contact": [],
    "Communication": [],
    "GeneralPractitioner": [],
    "ManagingOrganization": null,
    "Link": [],
    "Text": null,
    "Contained": [],
    "Extension": [],
    "ModifierExtension": [],
    "IdElement": {
      "Value": "'19065267'",
      "ElementId": null,
      "Extension": []
    },
    "Meta": null,
    "ImplicitRulesElement": null,
    "LanguageElement": null
  },
  "ThongTinVaoVien": [
    {
      "Location": {
        "Identifier": [
          {
            "UseElement": null,
            "Type": null,
            "SystemElement": null,
            "ValueElement": {
              "Value": "K03; K03",
              "ElementId": null,
              "Extension": []
            },
            "Period": null,
            "Assigner": null,
            "ElementId": null,
            "Extension": []
          }
        ],
        "StatusElement": {
          "Value": 0,
          "ElementId": null,
          "Extension": []
        },
        "OperationalStatus": null,
        "NameElement": {
          "Value": "Khoa Nội tổng hợp",
          "ElementId": null,
          "Extension": []
        },
        "AliasElement": [],
        "DescriptionElement": null,
        "ModeElement": {
          "Value": 1,
          "ElementId": null,
          "Extension": []
        },
        "Type": [],
        "Telecom": [],
        "Address": null,
        "PhysicalType": null,
        "Position": null,
        "ManagingOrganization": null,
        "PartOf": null,
        "HoursOfOperation": [],
        "AvailabilityExceptionsElement": null,
        "Endpoint": [],
        "Text": null,
        "Contained": [],
        "Extension": [],
        "ModifierExtension": [],
        "IdElement": {
          "Value": "K03; K03",
          "ElementId": null,
          "Extension": []
        },
        "Meta": null,
        "ImplicitRulesElement": null,
        "LanguageElement": null
      },
      "Condition": {
        "Identifier": [
          {
            "UseElement": null,
            "Type": null,
            "SystemElement": null,
            "ValueElement": {
              "Value": "J20",
              "ElementId": null,
              "Extension": []
            },
            "Period": null,
            "Assigner": null,
            "ElementId": null,
            "Extension": []
          }
        ],
        "ClinicalStatus": {
          "Coding": [
            {
              "SystemElement": {
                "Value": "http://terminology.hl7.org/CodeSystem/condition-clinical",
                "ElementId": null,
                "Extension": []
              },
              "VersionElement": {
                "Value": "4.0.1",
                "ElementId": null,
                "Extension": []
              },
              "CodeElement": {
                "Value": "resolved",
                "ElementId": null,
                "Extension": []
              },
              "DisplayElement": {
                "Value": "Resolved",
                "ElementId": null,
                "Extension": []
              },
              "UserSelectedElement": null,
              "ElementId": null,
              "Extension": []
            }
          ],
          "TextElement": null,
          "ElementId": null,
          "Extension": []
        },
        "VerificationStatus": {
          "Coding": [
            {
              "SystemElement": {
                "Value": "http://terminology.hl7.org/CodeSystem/condition-ver-status",
                "ElementId": null,
                "Extension": []
              },
              "VersionElement": {
                "Value": "4.0.1",
                "ElementId": null,
                "Extension": []
              },
              "CodeElement": {
                "Value": "confirmed",
                "ElementId": null,
                "Extension": []
              },
              "DisplayElement": {
                "Value": "Confirmed",
                "ElementId": null,
                "Extension": []
              },
              "UserSelectedElement": null,
              "ElementId": null,
              "Extension": []
            }
          ],
          "TextElement": null,
          "ElementId": null,
          "Extension": []
        },
        "Category": [],
        "Severity": null,
        "Code": {
          "Coding": [
            {
              "SystemElement": null,
              "VersionElement": null,
              "CodeElement": {
                "Value": "J20",
                "ElementId": null,
                "Extension": []
              },
              "DisplayElement": {
                "Value": "Viêm phế quản cấp",
                "ElementId": null,
                "Extension": []
              },
              "UserSelectedElement": null,
              "ElementId": null,
              "Extension": []
            }
          ],
          "TextElement": {
            "Value": "Viêm phế quản cấp",
            "ElementId": null,
            "Extension": []
          },
          "ElementId": null,
          "Extension": []
        },
        "BodySite": [],
        "Subject": {
          "ReferenceElement": {
            "Value": "Patient/'19065267'",
            "ElementId": null,
            "Extension": []
          },
          "TypeElement": null,
          "Identifier": null,
          "DisplayElement": null,
          "ElementId": null,
          "Extension": []
        },
        "Encounter": {
          "ReferenceElement": {
            "Value": "Encounter/19100213364897412500824",
            "ElementId": null,
            "Extension": []
          },
          "TypeElement": null,
          "Identifier": null,
          "DisplayElement": null,
          "ElementId": null,
          "Extension": []
        },
        "Onset": null,
        "Abatement": null,
        "RecordedDateElement": null,
        "Recorder": null,
        "Asserter": null,
        "Stage": [],
        "Evidence": [],
        "Note": [],
        "Text": {
          "StatusElement": null,
          "Div": "Viêm phế quản cấp",
          "ElementId": null,
          "Extension": []
        },
        "Contained": [],
        "Extension": [],
        "ModifierExtension": [],
        "IdElement": {
          "Value": "J20",
          "ElementId": null,
          "Extension": []
        },
        "Meta": null,
        "ImplicitRulesElement": null,
        "LanguageElement": null
      },
      "Organization": {
        "Identifier": [
          {
            "UseElement": null,
            "Type": null,
            "SystemElement": null,
            "ValueElement": {
              "Value": "25095",
              "ElementId": null,
              "Extension": []
            },
            "Period": null,
            "Assigner": null,
            "ElementId": null,
            "Extension": []
          }
        ],
        "ActiveElement": null,
        "Type": [],
        "NameElement": {
          "Value": "Trạm y tế xã Vụ Quang",
          "ElementId": null,
          "Extension": []
        },
        "AliasElement": [],
        "Telecom": [],
        "Address": [],
        "PartOf": null,
        "Contact": [],
        "Endpoint": [],
        "Text": null,
        "Contained": [],
        "Extension": [],
        "ModifierExtension": [],
        "IdElement": {
          "Value": "25095",
          "ElementId": null,
          "Extension": []
        },
        "Meta": null,
        "ImplicitRulesElement": null,
        "LanguageElement": null
      },
      "Encounter": {
        "Identifier": [
          {
            "UseElement": null,
            "Type": null,
            "SystemElement": null,
            "ValueElement": {
              "Value": "'19065267'",
              "ElementId": null,
              "Extension": []
            },
            "Period": null,
            "Assigner": null,
            "ElementId": null,
            "Extension": []
          },
          {
            "UseElement": null,
            "Type": null,
            "SystemElement": null,
            "ValueElement": {
              "Value": "25095",
              "ElementId": null,
              "Extension": []
            },
            "Period": null,
            "Assigner": null,
            "ElementId": null,
            "Extension": []
          },
          {
            "UseElement": null,
            "Type": null,
            "SystemElement": null,
            "ValueElement": {
              "Value": "19100213364897412500824",
              "ElementId": null,
              "Extension": []
            },
            "Period": null,
            "Assigner": null,
            "ElementId": null,
            "Extension": []
          },
          {
            "UseElement": null,
            "Type": null,
            "SystemElement": null,
            "ValueElement": {
              "Value": "2520285527",
              "ElementId": null,
              "Extension": []
            },
            "Period": null,
            "Assigner": null,
            "ElementId": null,
            "Extension": []
          }
        ],
        "StatusElement": {
          "Value": 5,
          "ElementId": null,
          "Extension": []
        },
        "StatusHistory": [
          {
            "StatusElement": {
              "Value": 5,
              "ElementId": null,
              "Extension": []
            },
            "Period": null,
            "ModifierExtension": [],
            "ElementId": null,
            "Extension": []
          }
        ],
        "Class": null,
        "ClassHistory": [],
        "Type": [],
        "ServiceType": {
          "Coding": [
            {
              "SystemElement": null,
              "VersionElement": null,
              "CodeElement": {
                "Value": "Outpatients",
                "ElementId": null,
                "Extension": []
              },
              "DisplayElement": {
                "Value": "Outpatients",
                "ElementId": null,
                "Extension": []
              },
              "UserSelectedElement": null,
              "ElementId": null,
              "Extension": []
            }
          ],
          "TextElement": {
            "Value": "Outpatients",
            "ElementId": null,
            "Extension": []
          },
          "ElementId": null,
          "Extension": []
        },
        "Priority": null,
        "Subject": {
          "ReferenceElement": {
            "Value": "Patient/'19065267'",
            "ElementId": null,
            "Extension": []
          },
          "TypeElement": null,
          "Identifier": null,
          "DisplayElement": null,
          "ElementId": null,
          "Extension": []
        },
        "EpisodeOfCare": [],
        "BasedOn": [],
        "Participant": [],
        "Appointment": [],
        "Period": {
          "StartElement": {
            "Value": "2020-01-07T00:00:00+07:00",
            "ElementId": null,
            "Extension": []
          },
          "EndElement": null,
          "ElementId": null,
          "Extension": []
        },
        "Length": null,
        "ReasonCode": [],
        "ReasonReference": [],
        "Diagnosis": [
          {
            "Condition": {
              "ReferenceElement": {
                "Value": "Condition/J20",
                "ElementId": null,
                "Extension": []
              },
              "TypeElement": null,
              "Identifier": null,
              "DisplayElement": null,
              "ElementId": null,
              "Extension": []
            },
            "Use": {
              "Coding": [
                {
                  "SystemElement": null,
                  "VersionElement": null,
                  "CodeElement": {
                    "Value": "DD",
                    "ElementId": null,
                    "Extension": []
                  },
                  "DisplayElement": {
                    "Value": "Discharge diagnosis",
                    "ElementId": null,
                    "Extension": []
                  },
                  "UserSelectedElement": null,
                  "ElementId": null,
                  "Extension": []
                }
              ],
              "TextElement": null,
              "ElementId": null,
              "Extension": []
            },
            "RankElement": null,
            "ModifierExtension": [],
            "ElementId": null,
            "Extension": []
          }
        ],
        "Account": [],
        "Hospitalization": {
          "PreAdmissionIdentifier": null,
          "Origin": {
            "ReferenceElement": {
              "Value": "Organization/25095",
              "ElementId": null,
              "Extension": []
            },
            "TypeElement": null,
            "Identifier": null,
            "DisplayElement": {
              "Value": "Trạm y tế xã Vụ Quang",
              "ElementId": null,
              "Extension": []
            },
            "ElementId": null,
            "Extension": []
          },
          "AdmitSource": null,
          "ReAdmission": null,
          "DietPreference": [],
          "SpecialCourtesy": [],
          "SpecialArrangement": [],
          "Destination": null,
          "DischargeDisposition": null,
          "ModifierExtension": [],
          "ElementId": null,
          "Extension": []
        },
        "Location": [
          {
            "Location": {
              "ReferenceElement": {
                "Value": "Location/K03; K03",
                "ElementId": null,
                "Extension": []
              },
              "TypeElement": null,
              "Identifier": null,
              "DisplayElement": {
                "Value": "Khoa Nội tổng hợp",
                "ElementId": null,
                "Extension": []
              },
              "ElementId": null,
              "Extension": []
            },
            "StatusElement": {
              "Value": 3,
              "ElementId": null,
              "Extension": []
            },
            "PhysicalType": null,
            "Period": {
              "StartElement": {
                "Value": "2020-01-07T00:00:00+07:00",
                "ElementId": null,
                "Extension": []
              },
              "EndElement": null,
              "ElementId": null,
              "Extension": []
            },
            "ModifierExtension": [],
            "ElementId": null,
            "Extension": []
          }
        ],
        "ServiceProvider": null,
        "PartOf": null,
        "Text": null,
        "Contained": [],
        "Extension": [],
        "ModifierExtension": [],
        "IdElement": {
          "Value": "19100213364897412500824",
          "ElementId": null,
          "Extension": []
        },
        "Meta": null,
        "ImplicitRulesElement": null,
        "LanguageElement": null
      }
    }
  ]
};


model.arrayChangePhone = [
  { from: "120", to: "070" },
  { from: "121", to: "079" },
  { from: "122", to: "077" },
  { from: "126", to: "076" },
  { from: "128", to: "078" },

  { from: "123", to: "083" },
  { from: "124", to: "084" },
  { from: "125", to: "085" },
  { from: "127", to: "081" },
  { from: "129", to: "082" },

  { from: "162", to: "032" },
  { from: "163", to: "033" },
  { from: "164", to: "034" },
  { from: "165", to: "035" },
  { from: "166", to: "036" },
  { from: "167", to: "037" },
  { from: "168", to: "038" },
  { from: "169", to: "039" },

  { from: "186", to: "056" },
  { from: "188", to: "058" },

  { from: "199", to: "059" }
];


export default model;